import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pt from 'vuetify/es5/locale/pt'
import { getCurrentClient, getBrand } from '@/config/brand'
import { DEFAULT_PRIMARY_COLOR, DEFAULT_SEMANTIC_COLORS } from '@/config/themeColors'

Vue.use(Vuetify)

const brand = getBrand(getCurrentClient())

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: DEFAULT_PRIMARY_COLOR, // #2146f5
        primarysoft: '#c2d4f4',
        primarysoft2: '#E3EAF5',
        secondary: '#F6F7FA', // Cinza-azulado claro
        background: '#f1f3f6', // #F0F3F5 #edf0f6
        optionprimary: '#3367d6',
        bluegreysoft: '#ABB4D4',
        bluegreydark: '#263238',
        bluegreylight: '#90A4AE',
        green: '#148EA4', // Verde
        grey: '#535D67', // Cinza
        greylight: '#707070',
        greysoft: '#d7d7d7',
        orange: '#FD701C',
        accent: '#82B1FF',
        info: DEFAULT_SEMANTIC_COLORS.info,
        success: DEFAULT_SEMANTIC_COLORS.success,
        warning: DEFAULT_SEMANTIC_COLORS.warning,
        error: DEFAULT_SEMANTIC_COLORS.error,
        clean: '#FFFFFF',
        purple: '#7f00c9',
        greydarken: '#3B3B3B',
        loginTheme: brand.colors.loginTheme,
        textLoginTheme: brand.colors.textLoginTheme,
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: 'mdi',
  },
})
